"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyAssets = getMyAssets;
exports.uploadImageOrDocumentAsset = uploadImageOrDocumentAsset;
exports.softDeleteAssets = softDeleteAssets;
exports.getUrlForVideoUpload = getUrlForVideoUpload;
exports.saveUploadedVideoAsset = saveUploadedVideoAsset;
exports.waitForVideoToBeProcessed = waitForVideoToBeProcessed;
exports.waitForVideoMp4VersionToBeProcessedAndGetDownloadUrl = waitForVideoMp4VersionToBeProcessedAndGetDownloadUrl;
const axios_1 = require("./clients/axios");
async function getMyAssets(assetType) {
    const params = {};
    if (assetType) {
        params.type = assetType;
    }
    const response = await axios_1.client.get('/0/asset', { params });
    return response.data;
}
async function uploadImageOrDocumentAsset({ uploadingAsset, onUploadProgress, }) {
    const formData = new FormData();
    formData.append('file', uploadingAsset.file);
    formData.append('type', uploadingAsset.type);
    const response = await axios_1.client.post('/0/asset/image-or-document', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: progressEvent => {
            if (onUploadProgress && progressEvent.total) {
                onUploadProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            }
        },
    });
    return response.data;
}
async function softDeleteAssets(assetIds) {
    await axios_1.client.delete('/0/asset', { params: { ids: assetIds } });
}
async function getUrlForVideoUpload() {
    const response = await axios_1.client.get('/0/asset/video-upload-url');
    return response.data;
}
async function saveUploadedVideoAsset({ uploadingAsset, muxDirectUploadId, }) {
    const response = await axios_1.client.post('/0/asset/video', {
        filename: uploadingAsset.file.name,
        size: uploadingAsset.file.size,
        muxDirectUploadId,
    });
    return response.data;
}
async function waitForVideoToBeProcessed(muxAssetId) {
    await axios_1.client.get('/0/asset/wait-for-video', { params: { muxAssetId } });
}
async function waitForVideoMp4VersionToBeProcessedAndGetDownloadUrl(muxAssetId) {
    const response = await axios_1.client.get('/0/asset/wait-for-video-mp4', { params: { muxAssetId } });
    return response.data.downloadUrl;
}
